import { HeaderMenu } from "components"
import { useSearchParams } from "react-router-dom"
import { TabProfile } from "./TabProfile"
import { TabNavTransaction } from "../components/TabNavTransaction"
import { TabTransactionPath } from "../types"
import { useState } from "react"
// import { useState } from "react"

type TabsSearchParams = {
    tabs: TabTransactionPath
}


export default function ProjectTransaction() {
    const [searchParams, setSearchParams] = useSearchParams({ tabs: "profile" } as TabsSearchParams)
    const activeTab = searchParams.get("tabs")
    const setActiveTab = (path: string) => setSearchParams({ tabs: path })
    const [projectCode, setProjectCode] = useState('')
    let disablePath = ["boq", "checklist", "task", "resources", "transaction", "dashboard", "address", "emedia"]
    

    return (
        <section className="container my-5">
            <HeaderMenu title="DATA ENTRY | PROJECT" action="create" className="sticky top-[0px] z-[1]" >
                <div>{projectCode}</div>
            </HeaderMenu>
            <TabNavTransaction activeTab={activeTab!} setActiveTab={setActiveTab} disablePath={disablePath}/>
            {activeTab === "profile" && <TabProfile  setProjectCode={setProjectCode}/>}
            {activeTab === "boq" && <></>}
        </section>
    )
}